<div class="h-full overflow-hidden bg-white border border-gray-200 rounded-lg shadow-xs">
	<a
		[routerLink]="urlParts"
		class="block h-56 p-4 bg-center bg-cover"
		[ngStyle]="{
			'background-image':
				'url(' + (article?.img_name ?? article?.image | cdn) + ')',
		}"
	>
		<span class="sr-only">Read full article titled {{ article?.title }}</span>
	</a>

	<div class="px-4 space-y-1 py-7">
		<a
			[routerLink]="['/advice/', article?.cat_name | categoryLink: 'advice']"
			class="block font-medium text-uc-blue-600"
		>
			{{ article?.cat_name.toLowerCase() | categoryName }}
		</a>

		<a class="block text-xl font-bold" [routerLink]="urlParts">
			{{ article?.title | ucEntities }}
		</a>
		<p class="pb-2 text-sm text-gray-500">
			{{ article?.date_posted | ucdate }}
			@if (article?.reading_time > 0) {
				&middot; {{ article?.reading_time }} min read
			}
		</p>

		<!-- display quote, else content -->
		@if (article?.quote) {
			<p
				class="text-base text-gray-500"
				[innerHTML]="article?.quote | truncate: [120]"
			></p>
		}
		@if (article?.content && !article?.quote) {
			<p
				class="text-base text-gray-500"
				[innerHTML]="article?.content | truncate: [120]"
			></p>
		}
	</div>
</div>
